import { useRef } from "react";
import ShowItemContent from "../items/ShowItemContent";
import { isVisuallyEmptyTextEditor, removeTrailingEmptyLinesTextEditor } from "../../../../../../../../../EHR/EHR Settings/Templates/OpenTemplate/FormBuilder/utils/utils";

const FormattingTextField = ({ item, isGroupNote }) => {
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;
    let formattingNoteText = removeTrailingEmptyLinesTextEditor(item.content || '');
    let divContent  = 
      <>
        {isVisuallyEmptyTextEditor(item.content) ?
        noValExistText :
        <p className="text" dangerouslySetInnerHTML={{ __html: formattingNoteText }}></p>}
    </>
  return (<>
    {item.content?.trim() ?
      <>
      {ShowItemContent(item, isGroupNote, divContent)}
    </>: <></>}
  </>
  )
}

export default FormattingTextField